import WrapColumn from "./wrap-column";

export default WrapColumn;